const colors = {
    white: '#FFFFFF',
    black: '#000000',
    grey: '#999999',
    yellow: '#EFC417',
};

const fonts = {
    base: 'Verdana, sans-serif',
    heading: "'Limelight', sans-serif",
    menu: "'Autour One', sans-serif",
};

export default { colors, fonts };
